
import Glide from '@glidejs/glide';

(function() {

    (function () {
        const productsCarousel = document.querySelector('#productsCarousel');
        if (!productsCarousel) return false;
        new Glide(productsCarousel, {
            type: 'carousel',
            startAt: 0,
            perView: 3,
            autoplay: false,
            hoverpause: true,
            rewind: true,
            keyboard: true,
            breakpoints: {
                320: {
                    perView: 1,
                      peek: {
                        before: 40,
                        after: 80
                      },
                },
                480: {
                    perView: 1,
                    peek: {
                        before: 5,
                        after: 50,
                      },
                },
                560: {
                    perView: 2,
                },
                768: {
                    perView: 2,
                },
                1024: {
                    perView: 3,
                },
                1280: {
                    perView: 3,
                }
            }
        }).mount();
    }());

    (function () {
        const carouselAparateStropit = document.querySelector('#carouselAparateStropit');
        if (!carouselAparateStropit) return false;
        new Glide(carouselAparateStropit, {
            type: 'carousel',
            startAt: 0,
            perView: 3,
            autoplay: false,
            hoverpause: true,
            rewind: true,
            keyboard: true,
            breakpoints: {
                360: {
                    perView: 1,
                },
                480: {
                    perView: 1,
                },
                560: {
                    perView: 2,
                },
                768: {
                    perView: 2,
                },
                1024: {
                    perView: 3,
                },
                1280: {
                    perView: 3,
                }
            }
        }).mount();
    }());

}());


// WEBPACK FOOTER //
// ./src/js/module/products-slider.js